// Helper to create email auto-suggest API handler for ExpenseCodeHalfcard
import { emailAutoSuggestPublic } from "@payment-client/apis/EmailAutoSuggest";
import { DOWNSTREAM_HOSTS } from "@payment-client/constants/Hosts";
import { IApiCallHandlers } from "@swiggy-private/payment-ui";
import { NEWRELIC_TABLES, recordNREvent } from "@swiggy-private/checkout-core";

export interface EmailOption {
    businessEmailId: string;
    businessEmailCommId: string;
    firstName?: string;
    lastName?: string;
}

export function createEmailAutoSuggestHandler(): IApiCallHandlers {
    return {
        email: async (searchKey: string): Promise<EmailOption[]> => {
            try {
                const response = await emailAutoSuggestPublic(DOWNSTREAM_HOSTS.API_HOST, searchKey);

                // Return full employee objects with businessEmailId and businessEmailCommId
                return response?.data?.employees || [];
            } catch (error) {
                recordNREvent({
                    eventType: NEWRELIC_TABLES.EMAIL_AUTO_SUGGEST_ERROR,
                    searchKey,
                    error: error instanceof Error ? error.message : String(error),
                });
                return [];
            }
        },
    };
}
